module.exports = "/remote-dist/91df40eacceb6ba96201b3e3ad201f85.png";